import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'kodit-pdv-evidencija-zbirna-page',
  templateUrl: './pdv-evidencija-zbirna-page.component.html',
  styleUrls: ['./pdv-evidencija-zbirna-page.component.scss'],
})
export class PdvEvidencijaZbirnaPageComponent implements OnInit {
  novaTabelaSelected: boolean = true;
  tableOptions: SelectItem[] = [];

  ngOnInit(): void {
    this._loadDropdownOptions();
  }

  private _loadDropdownOptions() {
    this.tableOptions.push({
      value: VrstaZbirneEvidencije.SEF_39,
      label: 'SEF 3.9',
    });

    this.tableOptions.push({
      value: VrstaZbirneEvidencije.STARA,
      label: 'Stare',
    });
  }

  optionChanged(event: any) {
    this.novaTabelaSelected = event.value === VrstaZbirneEvidencije.SEF_39;
  }
}

export enum VrstaZbirneEvidencije {
  STARA = 0,
  SEF_39 = 1,
}
